import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth-pages)")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
